<script setup lang="ts">
</script>

<template>
  <div
    class="customer-reviews"
    aria-labelledby="customer-reviews-title"
  >
    <div class="customer-reviews__container container">
      <header class="customer-reviews__header">
        <h2
          id="customer-reviews-title"
          class="customer-reviews__title"
        >
          Klantbeoordelingen
        </h2>

        <div class="customer-reviews__summary">
          <span class="customer-reviews__score">4.63</span>

          <span class="customer-reviews__source">
            op TrustedShops
            <strong class="customer-reviews__count">1.457</strong>
            reviews
          </span>
        </div>
      </header>

      <div class="customer-reviews__grid">
        <article class="customer-review-card">
          <h3 class="customer-review-card__title">
            Ruim aanbod en snel verzonden.
          </h3>

          <p class="customer-review-card__text">
            Zoals meestal net even wat goedkoper dan andere adresjes, leuke actieprijzen en altijd snel verzonden.
          </p>

          <p class="customer-review-card__meta">
            Anoniem op
            <time datetime="2025-06-05">17-05-2026</time>
          </p>
        </article>

        <article class="customer-review-card">
          <h3 class="customer-review-card__title">
            Steeds weer uitstekend.
          </h3>

          <p class="customer-review-card__text">
            Diverse malen heb ik artikelen bij Bagageonline besteld. het zijn mooie kwaliteitsproducten. Steeds was de levering heel correct en op tijd!
          </p>

          <p class="customer-review-card__meta">
            Anoniem op
            <time datetime="2025-06-05">27-04-2026</time>
          </p>
        </article>

        <article class="customer-review-card">
          <h3 class="customer-review-card__title">
            Goed product en snel geleverd.
          </h3>

          <p class="customer-review-card__text">
            Pakket was netjes op tijd geleverd en tassen zelf zijn van top kwaliteit, geen seconde spijt van gehad!
          </p>

          <p class="customer-review-card__meta">
            Anoniem op
            <time datetime="2025-06-05">05-12-2025</time>
          </p>
        </article>
      </div>
    </div>
  </div>
</template>

<style>
@import url("~layers/app/components/App/CustomerReviews.css");
</style>
